import { useAuth } from "@/lib/auth";
import { hasMinRole } from "@/lib/rbac";
import { useEntitlement } from "@/hooks/use-entitlements";

/**
 * Whether this person can hand work to fastn's agent (/agent): the role the
 * page is gated on AND the aiBuilder.integrations entitlement. Gating on the
 * role alone let an org without the entitlement type a request, create a
 * session, and be bounced by /agent's EntitlementGate with the request gone.
 * False only on a SETTLED "no": while entitlements load the answer stays yes,
 * and a failed read still hands off, because /agent says so rather than
 * redirecting.
 */
export function useCanBuildWithAi(): boolean {
  const { userContext, contextPending } = useAuth();
  const agentEntitlement = useEntitlement("aiBuilder.integrations");
  const agentNotEntitled = !contextPending && !agentEntitlement.isLoading && !agentEntitlement.isError && !agentEntitlement.enabled;
  return hasMinRole(userContext?.role ?? "end_user", "operator") && !agentNotEntitled;
}
